import _ from "lodash";
import {Space} from "antd";
import React from "react";
import {pp} from "~/utils.js";

export default ({d, teamById, small}) => {
  if (d.status !== "done" || !d.ranking || !d.ranking[0] || !d.ranking[0][0])
    return null;

  let top3 = _.take(d.ranking, 3)

  let ranks = [
    { name: 'Gold', className: 'bg-yellow-100 text-yellow-800 border border-yellow-200', medal: "🥇", bg: "linear-gradient(90deg, #ffed4e, #ffd700)" },
    { name: 'Silver', className: 'bg-gray-100 text-gray-700 border border-gray-200', medal: "🥈", bg: "linear-gradient(90deg, #e8e8e8, #c0c0c0)" },
    { name: 'Bronze', className: 'bg-orange-50 text-amber-900 border border-orange-100', medal: "🥉", bg: "linear-gradient(90deg, #daa520, #cd7f32)" },
  ]

  return <div className="space-x-2" style={{overflowX: 'auto'}}>
    <Space>
      {top3.map(rank => {

        if (!rank || rank[0] > 3)
          return null;

        let t = teamById[rank[1]];
        let {name, className, medal, bg} = ranks[rank[0]-1];

        return <div key={name} className={`rounded ${small ? "px-2 py-1" : "p-2"} ${className}`} style={{background: bg}}>
          { !small && <div className="text-xs font-medium">{name} {medal}</div> }
          <div className="text-sm">
            <Space size={2}>
              {small && medal}
              {t.name}
            </Space>
          </div>
        </div>}
      )}
    </Space>
  </div>
}
